import PropTypes from 'prop-types'
import { RadioGroupItem, RadioGroup } from '@components/ui/radio-group'
import { Label } from '@components/ui/label'
import { cn } from 'lib/utils'

export const AdasRadio = ({
  value,
  label,
  disabled,
  className,
  id,
  checked,
  onChange,
  // eslint-disable-next-line no-unused-vars
  inputProps,
  // eslint-disable-next-line no-unused-vars
  size,
  // eslint-disable-next-line no-unused-vars
  sx,
  name,
  ...props
}) => {
  const radioId = id || `radio-${value}`
  const isStandalone = checked !== undefined || onChange !== undefined

  if (isStandalone) {
    return (
      <div className={cn('flex items-center gap-[10px]', className)}>
        <RadioGroup value={checked ? String(value) : ''} onValueChange={() => onChange && onChange({ target: { value, name } })}>
          <RadioGroupItem value={String(value)} id={radioId} disabled={disabled} {...props} />
        </RadioGroup>
        {label && (
          <Label htmlFor={radioId} className='text-[14px] font-normal text-foreground cursor-pointer'>
            {label}
          </Label>
        )}
      </div>
    )
  }

  return (
    <div className={cn('flex items-center gap-[10px]', className)}>
      <RadioGroupItem value={value} id={radioId} disabled={disabled} {...props} />
      {label && (
        <Label htmlFor={radioId} className='text-sm cursor-pointer'>
          {label}
        </Label>
      )}
    </div>
  )
}

AdasRadio.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  name: PropTypes.string
}
